<template>
    <div class="content-grid-collection" v-if="data && contentType" :class="contentType">
        <transition name="slow-fade">
            <div class="items-wrapper" v-if="contentType && contentType.includes('artikelen')">
                <ul>
                    <li :class="contentType.toLowerCase()" v-for="item in data" :key="item.id">
                        <BlogOverviewItem :data="item" />
                    </li>
                </ul>
            </div>

        </transition>
        <transition name="slow-fade">
            <div class="items-wrapper" v-if="contentType && contentType.includes('faq')">
                <ul>
                    <li :class="contentType.toLowerCase()" v-for="item in data" :key="item.id">
                        <FaqItem :data="item" />
                    </li>
                </ul>
            </div>
        </transition>
        <transition name="slow-fade">
            <div class="items-wrapper" v-if="contentType && contentType.includes('day')">
                <ul>
                    <li :class="contentType.toLowerCase()" v-for="item in data" :key="item.id">
                        <DayOverviewItem :data="item" />
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
// @import component
// import ClassOverviewItem from "@/components/ClassOverviewItem";

import { defineAsyncComponent } from "vue";

const BlogOverviewItem = defineAsyncComponent(() => import("@/components/BlogOverviewItem"));
const FaqItem = defineAsyncComponent(() => import("@/components/FaqItem"));
const DayOverviewItem = defineAsyncComponent(() => import("@/components/DayOverviewItem"));

export default {
    name: "ContentGridCollection",
    components: {
        BlogOverviewItem,
        FaqItem,
        DayOverviewItem
    },
    inject: ["isAuthenticated"],
    data() {
        return {};
    },
    props: ["data", "contentType", 'overviewItemType'],
    created() {

    },
};
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>
